import axios from "axios";
import { useGoogleLogin, type TokenResponse } from "@react-oauth/google";
import { useAuthStore } from "../stores/useAuthStore"; // sesuaikan path store Anda
import type { UserData } from "../types";
import { toast } from "sonner";
import { BACKEND_URL } from "@/constants";
import { useState } from "react";
import { useChatStore } from "@/stores/useChatStore";
import { useUIStore } from "@/stores/useUIStore";
import { aktTarget, prodiTarget } from "shared";
import { elysiaErr } from "@/lib/elysiaErr";

export const useGoogleAuth = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const setAuth = useAuthStore((state) => state.setAuth);
    const setFeedbackNumber = useAuthStore((s) => s.setFeedbackNumber);
    const setRecScores = useAuthStore((s) => s.setRecScores);
    const setSelectedMatkulItems = useAuthStore((s) => s.setSelectedMatkulItems);
    const setRating = useAuthStore((s) => s.setRating);
    const setTags = useChatStore((s) => s.setTags);
    const clearMessages = useChatStore((s) => s.clearMessages);
    const setHasBeenCalonWinner = useUIStore((s) => s.setHasBeenCalonWinner);

    const handleGoogleSuccess = async (tokenResponse: TokenResponse) => {
        try {
            setIsLoading(true); // 🚀 Mulai loading sebelum request api berjalan

            // 1. Ambil data profil dari Google API
            const resG = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
                headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
            });

            const email = resG.data.email.toLowerCase();
            // const email = 'H1101201065@student.untan.ac.id'; // !!!! 1
            // const email = 'H1101231001@student.untan.ac.id'; // target !!!! 65

            // Regex ini menangkap huruf di depan (jika ada) dan semua angka setelahnya sebelum tanda @
            const nimMatch = email.match(/^([a-zA-Z0-9]+)@/);
            let nim = nimMatch ? nimMatch[1].toUpperCase() : null;

            let isTarget = false;
            let isStudentNonTarget = false;
            let nimProd;
            if (email.endsWith('@student.untan.ac.id') && nim) {
                nimProd = nim.slice(0, 3)
                if (prodiTarget.has(nimProd)
                    && aktTarget.has(nim.slice(5, 7))) {
                    isTarget = true;
                } else {
                    isStudentNonTarget = true;
                }
            } else {
                toast.warning(`Public access, Dummy Data Rekomendasi.`);
            }

            // Kirim data ke Backend untuk mendapatkan JWT Token
            const backendRes = await axios.post(`${BACKEND_URL}/auth/google`, {
                accessToken: tokenResponse.access_token,
                email, isTarget,
            });
            console.log("Response dari backend:", backendRes.data); // Debug: lihat response dari backend

            const jwtToken = backendRes.data.token;
            const studentId = backendRes.data.studentId;
            if (studentId && isStudentNonTarget) {
                toast.warning(`Bukan target, tapi ada riwayat nilai.`);
            }
            const userData: UserData = {
                email,
                isTarget,
                studentId,
                name: resG.data.name,
                givenName: resG.data.given_name,
                picture: resG.data.picture,
                nimProd,
            };

            console.log("userData", userData);
            setAuth(userData, jwtToken);
            const accessLoaded: string[] = ['Kritik']; // all user


            // simpan recomendation Tampilkan notifikasi dapat akses fitur rekomendasi.
            accessLoaded.push('Rekomendasi Matkul');
            // notif pakai toast sonner
            const rec: Record<string, number> = backendRes.data.recommendations;
            const sortedScores = Object.entries(rec)
                .sort(([, a], [, b]) => b - a);
            setRecScores(sortedScores); // matkul, category score, category_matkul

            const UFN = backendRes.data.nUserFeedback;
            const UA = backendRes.data.userAchievement;
            if ((UFN && UFN >= 4) // calon 2nd winner
                && (UA && UA.length >= 15)
                && backendRes.data.userScore) {
                setHasBeenCalonWinner(true);
                accessLoaded.push('LLM');
            }

            toast.success(`Dapat akses [${accessLoaded.join(', ')}].`, { position: "top-center" });

            const dataLoaded: string[] = [];

            if (UFN && UFN > 0) {
                setFeedbackNumber(UFN);
                dataLoaded.push("Feedback");
            }

            if (backendRes.data.userRecomTarget) { // jika sudah pernah submit matkul
                // console.log("backendRes.data.userRecomTarget", backendRes.data.userRecomTarget);
                setSelectedMatkulItems(backendRes.data.userRecomTarget.itemIds)
                dataLoaded.push("Selected Matkul");
            }

            // jika ada progress achivement
            if (UA) {
                clearMessages()// reset ulang message, handle tags inconsistent
                setTags(UA);
                dataLoaded.push("Achievement");
            }
            if (backendRes.data.userScore) {
                dataLoaded.push("Rating");
                const score = backendRes.data.userScore;
                setRating({
                    scoreCf: score.scoreCf,
                    scoreChat: score.scoreChat,
                    message: score.message || ""
                });
            }

            if (dataLoaded.length > 0) toast.info(`Riwayat [${dataLoaded.join(', ')}] dimuat.`, { position: "top-center" });
        } catch (err: any) {
            elysiaErr(err);
        } finally {
            setIsLoading(false);
        }
    };

    const login = useGoogleLogin({
        onSuccess: handleGoogleSuccess,
        // onError: () => // console.log("Login Failed"),
    });

    return { login, isLoading };
};